import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import Line_Chart_Value_Edit from "./Line_Chart_Value_Edit";
import Bar_Chart_Value_Edit from "./Bar_Chart_Value_Edit";
import Pie_Chart_Value_Edits from "./Pie_Chart_Value_Edits";
import { store } from "../../../..";
import {
  set_edit_chart_modal_status,
  setnew_element,
} from "../../../../slices/dashboard/reducer";
import { Chart } from "chart.js";
import { Chart as ChartComp } from "react-chartjs-2";
// import ChartDataLabels from "chartjs-plugin-datalabels";


const Chart_Edit_Values_Popup = () => {
  const [modal_large, setmodal_large] = useState(false);
  const [sample_chart, setsample_chart] = useState(null);
  const chartRef_original = useRef(null);
  const { edit_chart_modal_status, title_id, new_element, edit_element_id } =
    useSelector((state) => state.Dashboard);
  function tog_large() {
    // setmodal_large(!modal_large);
    store.dispatch(set_edit_chart_modal_status(!modal_large));
    store.dispatch(setnew_element([]));
  }

  function getChartJSInstance() {
    // Get the grid item
    const gridItem = document.querySelector(`[gs-id="${edit_element_id}"]`);
    if (!gridItem) return null;

    // Get the canvas element
    const canvas = gridItem.querySelector("canvas");
    if (!canvas) return null;

    // Get Chart.js instance
    const chartInstance = Chart.getChart(canvas);
    chartRef_original.current = chartInstance;
    return chartInstance;
  }

  function getApexChartInstance(gsId) {
    const gridItem = document.querySelector(`[gs-id="${gsId}"]`);
    if (!gridItem) return null;

    // ApexCharts creates a div with class 'apexcharts-canvas'
    const apexContainer = gridItem.querySelector(".apexcharts-canvas");
    if (!apexContainer) return null;

    // Get the chart ID from the SVG
    const svg = apexContainer.querySelector("svg");
    if (!svg) return null;

    const chartId = svg.getAttribute("id");

    // Access ApexCharts instance using the chart ID
    // ApexCharts stores instances in window.ApexCharts.exec
    return {
      chartId: chartId,
      chart: ApexCharts.getChartByID(chartId),
    };
  }

  useEffect(() => {
    setmodal_large(edit_chart_modal_status);
  }, [edit_chart_modal_status]);

  useEffect(() => {
    const chart_element = new_element.filter(
      (ele) => ele.id == edit_element_id
    );
    console.log(chart_element);

    // Fix: Check if chart_element exists and has the correct type
    if (edit_element_id && chart_element.length > 0) {
      const elementType = chart_element[0].type; // Assuming type is stored in the element

      // Check if it's a chart type
      if (
        elementType === "line" ||
        elementType === "pie" ||
        elementType === "bar"
      ) {
        const chart = getChartJSInstance();

        if (chart) {
          console.log("Chart Type:", chart.config.type);
          console.log("Chart Data:", chart.data);
          console.log("Labels:", chart.data.labels);
          console.log("Datasets:", chart.data.datasets);

          // Create a deep copy of the chart configuration
          const chartCopy = {
            type: chart.config.type,
            data: {
              labels: [...chart.data.labels],
              datasets: chart.data.datasets.map((dataset) => ({
                ...dataset,
                data: [...dataset.data],
              })),
            },
            options: JSON.parse(JSON.stringify(chart.config.options || {})),
          };

          setsample_chart(chartCopy);

          // Use the chartCopy to create a new chart instance or store it
          // For example:
          // new Chart(newCanvasContext, chartCopy);
        }
      }
    }
  }, [edit_element_id]);

  return (
    <>
      <Button color="secondary" onClick={() => tog_large(true)}>
        Chart Edit
      </Button>
      {/* Large Modal */}
      <Modal
        size="xl"
        isOpen={modal_large}
        toggle={() => {
          tog_large();
        }}
      >
        <ModalHeader
          className="modal-title"
          id="myLargeModalLabel"
          toggle={() => {
            tog_large();
          }}
        >
          Edit Chart Values
        </ModalHeader>
        <ModalBody>
          {/* <Line_Chart_Value_Edit /> */}
          <Pie_Chart_Value_Edits
            sample_chart={sample_chart}
            setsample_chart={setsample_chart}
            original_chart={getChartJSInstance()}
          >
            {" "}
            <ChartComp
              type={sample_chart?.type}
              options={sample_chart?.options}
              data={sample_chart?.data}
            />
          </Pie_Chart_Value_Edits>
          {/* <Bar_Chart_Value_Edit /> */}
        </ModalBody>
        <div className="modal-footer">
          <Button
            className="btn btn-light fw-medium"
            onClick={() => setmodal_large(false)}
          >
            Cancel
          </Button>
          <Button color="secondary">Save changes</Button>
        </div>
      </Modal>
    </>
  );
};

export default Chart_Edit_Values_Popup;
